"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionClusters = void 0;
const React = require("react");
const core_1 = require("@material-ui/core");
const Generic_1 = require("../../legends/Generic");
require("./SelectionClusters.scss");
const react_redux_1 = require("react-redux");
const Adjust_1 = require("@material-ui/icons/Adjust");
const SelectionClustersFull = function ({ dataset, currentAggregation, hoverState }) {
    if (!dataset) {
        return null;
    }
    return React.createElement("div", { className: "Parent" },
        React.createElement("div", { className: "Cluster" }, hoverState && hoverState.length > 0 && React.createElement(core_1.Card, { style: { pointerEvents: 'auto' } },
            React.createElement(core_1.CardContent, { style: { padding: '8px' } },
                React.createElement(core_1.Typography, { align: "center", gutterBottom: true, variant: "body1" }, "Hover State"),
                React.createElement(Generic_1.GenericLegend, { aggregate: false, type: dataset.type, vectors: hoverState })))),
        React.createElement("div", { className: "Cluster" },
            React.createElement(core_1.Card, { style: { position: 'relative', pointerEvents: 'auto' } },
                currentAggregation.length > 0 && React.createElement("div", { style: { position: 'absolute', right: '0px', top: '0px' }, draggable: true, onDragStart: (event) => {
                        event.persist();
                    } },
                    React.createElement(Adjust_1.default, null)),
                React.createElement(core_1.CardContent, { style: { padding: '8px' } },
                    React.createElement(core_1.Typography, { align: "center", gutterBottom: true, variant: "body1" }, `Fingerprint (${currentAggregation.length})`),
                    React.createElement(Generic_1.GenericLegend, { aggregate: true, type: dataset.type, vectors: currentAggregation })))));
};
const mapStateToProps = state => ({
    currentAggregation: state.currentAggregation,
    hoverState: state.hoverState,
    dataset: state.dataset
});
exports.SelectionClusters = react_redux_1.connect(mapStateToProps)(SelectionClustersFull);
